import { FC, useState } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import { useRouter } from 'next/router';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { locale } = useRouter();
    const { t } = useLang('dp3.landing.EffortlessApp');
    const usObj = {
        pcA: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718780572169/a1.png',
        h5A: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718780731614/b1.png',
        pcB: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718780599913/a3.png',
        h5B: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718780780466/b2.png',
        pcC: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718780586581/a2.png',
        h5C: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718780811577/b3.png',
    };
    const jpObj = {
        pcA: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718872842221/a1.jpg',
        h5A: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718872912597/b1.jpg',

        pcB: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718872855806/a2.jpg',
        h5B: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718872926991/b2.jpg',

        pcC: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718872897805/a3.jpg',
        h5C: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718872942855/b3.jpg',
    };
    const cnObj = {
        pcA: 'https://websiteoss.ecoflow.com/upload/image/1737786090104/6_1.jpg',
        h5A: 'https://websiteoss.ecoflow.com/upload/image/1737786089507/6_1_M.jpg',

        pcB: 'https://websiteoss.ecoflow.com/upload/image/1737786089695/6_2.jpg',
        h5B: 'https://websiteoss.ecoflow.com/upload/image/1737786089910/6_2_M.jpg',

        pcC: 'https://websiteoss.ecoflow.com/upload/image/1737786090468/6_3.jpg',
        h5C: 'https://websiteoss.ecoflow.com/upload/image/1737786090283/6_3_M.jpg',
    };
    const imgObj = locale === 'cn' ? cnObj : locale === 'jp' ? jpObj : usObj;
    const [list, setList] = useState([
        {
            pc: imgObj.pcA,
            h5: imgObj.h5A,
            title: t('item1_title'),
            desc: t('item1_desc'),
            dir: 't',
        },
        {
            pc: imgObj.pcB,
            h5: imgObj.h5B,
            title: t('item2_title'),
            desc: t('item2_desc'),
            dir: 'r',
        },
        {
            pc: imgObj.pcC,
            h5: imgObj.h5C,
            title: t('item3_title'),
            desc: t('item3_desc'),
            dir: 'l',
        },
    ]);
    return (
        <div className={`${css.thecomp} GtmModuleData-section`} data-section-id={'dp3-EffortlessApp'} data-section-title={t('title')}>
            <div className="dp3-title">{t('title')}</div>
            <div className="comp-module">
                {list.map((item, index) => (
                    <div key={index} className={`comp-item comp-item-dir-${item.dir} comp-item-${index + 1}`}>
                        <div className="comp-item-msg">
                            <div className="comp-item-title">{item.title}</div>
                            <div className="comp-item-desc">{item.desc}</div>
                        </div>
                        <div className="comp-item-img">
                            <EditorImg pc={item.pc} h5={item.h5} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TheComp;
